//============================================================================================================
//Function to check if a user has permission for a specific module and action
// This function takes an array of roles, a module name, and an optional action name.
// It returns true if the user has the required permission, otherwise false.
//============================================================================================================
export function hasPermission(roles, moduleName, actionName = null) {

    // Check if roles are valid
    if (!roles || !Array.isArray(roles)) {
        // Return false if roles are not provided or not an array
        return false;
    }

    // Maps the roles to their string values for easier comparison
    const roleValues = roles.map(role => role?.Value);

    // If the Menu has no direct action to the module, just check if the user has at least basic access, like Read, List, (or if Admin)
    if (actionName === null || actionName === undefined) {
        const hasBasicAccess = roleValues.some(role =>
            role.startsWith(`${moduleName}`) &&
            (role.endsWith('Read') || role.endsWith('List') || role.endsWith('Admin'))
        );
        // Returns true if the user has basic access to the module
        // Returns false if user can't read, list or is not an admin of the module with no direct action defined
        return hasBasicAccess;
    }

    //At this point, the Menu has an action defined to the module, so we check if the user has access to that specific action
    // Constructs the expected permission string based on the module and action
    const expectedPermission = `${moduleName}${actionName}`;
    //Constructs an admin permission string for the module
    const adminPermission = `${moduleName}Admin`;
    // Checks if the user has the expected permission or admin permission
    const hasAccess = roleValues.includes(expectedPermission) || roleValues.includes(adminPermission);

    //Returns true if the user has the expected permission or admin permission
    //Returns false if the user does not have the expected permission or admin permission
    return hasAccess;
}
